import { masks, onlyNumbers } from 'util/mask'

import { MaskedField, MaskedFieldProps } from '../final-form'

export const ChaveField = (props: MaskedFieldProps) => {
  return <MaskedField mask={masks.chave} parse={onlyNumbers} {...props} />
}
